import { c as _c } from "react/compiler-runtime";
import { type ComponentProps } from 'react';
export const ShareIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M15.6 15.712C14.916 15.712 14.304 15.982 13.836 16.405L8.319 13.57C8.364 13.363 8.4 13.156 8.4 12.94C8.4 12.724 8.364 12.517 8.319 12.31L16.464 7.71104C16.95 8.16104 17.589 8.44004 18.3 8.44004C19.794 8.44004 21 7.23404 21 5.74004C21 4.24604 19.794 3.04004 18.3 3.04004C16.806 3.04004 15.6 4.24604 15.6 5.74004C15.6 5.95604 15.636 6.16304 15.681 6.37004L7.536 10.969C7.05 10.519 6.411 10.24 5.7 10.24C4.206 10.24 3 11.446 3 12.94C3 14.434 4.206 15.64 5.7 15.64C6.411 15.64 7.05 15.361 7.536 14.911L13.044 17.755C12.999 17.944 12.972 18.142 12.972 18.34C12.972 19.789 14.151 20.968 15.6 20.968C17.049 20.968 18.228 19.789 18.228 18.34C18.228 16.891 17.049 15.712 15.6 15.712Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};